import React from 'react'
import CaseContext from '../contexts/CaseContext'

export default function useCase () {
  return React.useContext(CaseContext)
}
